import { GalleryScreen } from "./Gallery.style"
import VerticalTabs from "../../components/VerticalTabs"

import FoliokGallery from "./FoliokGallery"
import AmenitiesGallery from "./AmenitiesGallery"
import ResidencesGallery from "./ResidencesGallery"
import LifestyleGallery from "./LifestyleGallery"

const tabs = [
  {
    name: "FOLIO GARDENS",
    component: FoliokGallery
  },
  {
    name: "RESIDENCES",
    component: ResidencesGallery
  },
  {
    name: "AMENITIES",
    component: AmenitiesGallery
  },
  {
    name: "LIFESTYLE",
    component: LifestyleGallery
  }
]

const Gallery = ({ match: { url } }) => (
  <GalleryScreen>
    <VerticalTabs path={url} tabs={tabs} />
  </GalleryScreen>
)

export default Gallery
